export const FETCH_VEHICLES_REQUEST = 'FETCH_VEHICLES_REQUEST';
export const FETCH_VEHICLES_SUCCESS = 'FETCH_VEHICLES_SUCCESS';
export const FETCH_VEHICLES_FAILED = 'FETCH_VEHICLES_FAILED';

export const FETCH_VEHICLE_BY_ID_REQUEST = 'FETCH_VEHICLE_BY_ID_REQUEST';
export const FETCH_VEHICLE_BY_ID_SUCCESS = 'FETCH_VEHICLE_BY_ID_SUCCESS';
export const FETCH_VEHICLE_BY_ID_FAILED = 'FETCH_VEHICLE_BY_ID_FAILED';

export const FETCH_VEHICLE_ORGS_BY_ID_REQUEST = 'FETCH_VEHICLE_ORGS_BY_ID_REQUEST';
export const FETCH_VEHICLE_ORGS_BY_ID_SUCCESS = 'FETCH_VEHICLE_ORGS_BY_ID_SUCCESS';
export const FETCH_VEHICLE_ORGS_BY_ID_FAILED = 'FETCH_VEHICLE_ORGS_BY_ID_FAILED';

export const FETCH_VEHICLE_TYPE_BY_ID_REQUEST = 'FETCH_VEHICLE_TYPE_BY_ID_REQUEST';
export const FETCH_VEHICLE_TYPE_BY_ID_SUCCESS = 'FETCH_VEHICLE_TYPE_BY_ID_SUCCESS';
export const FETCH_VEHICLE_TYPE_BY_ID_FAILED = 'FETCH_VEHICLE_TYPE_BY_ID_FAILED';

export const FETCH_DELETE_VEHICLE_REQUEST = 'FETCH_DELETE_VEHICLE_REQUEST';
export const FETCH_DELETE_VEHICLE_SUCCESS = 'FETCH_DELETE_VEHICLE_SUCCESS';
export const FETCH_DELETE_VEHICLE_FAILED = 'FETCH_DELETE_VEHICLE_FAILED';
export const RESET_DELETE_VEHICLE_SUCCESS = 'RESET_DELETE_VEHICLE_SUCCESS';
export const RESET_VEHICLES_SUCCESS = 'RESET_VEHICLES_SUCCESS';

export const FETCH_VEHICLES_ASSET_CLASSES_REQUEST = 'FETCH_VEHICLES_ASSET_CLASSES_REQUEST';
export const FETCH_VEHICLES_ASSET_CLASSES_SUCCESS = 'FETCH_VEHICLES_ASSET_CLASSES_SUCCESS';
export const FETCH_VEHICLES_ASSET_CLASSES_FAILED = 'FETCH_VEHICLES_ASSET_CLASSES_FAILED';

export const FETCH_CREATE_VEHICLE_REQUEST = 'FETCH_CREATE_VEHICLE_REQUEST';
export const FETCH_CREATE_VEHICLE_SUCCESS = 'FETCH_CREATE_VEHICLE_SUCCESS';
export const FETCH_CREATE_VEHICLE_FAILED = 'FETCH_CREATE_VEHICLE_FAILED';

export const RESET_VEHICLE_TYPE_ONBOARDING = 'RESET_VEHICLE_TYPE_ONBOARDING';
export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const CHANGE_POSITION = 'CHANGE_POSITION';
export const SET_EXIT = 'SET_EXIT';

export const FETCH_VEHICLES_TYPES_REQUEST = 'FETCH_VEHICLES_TYPES_REQUEST';
export const FETCH_VEHICLES_TYPES_SUCCESS = 'FETCH_VEHICLES_TYPES_SUCCESS';
export const FETCH_VEHICLES_TYPES_FAILED = 'FETCH_VEHICLES_TYPES_FAILED';
export const RESET_VEHICLES_TYPES_SUCCESS = 'RESET_VEHICLES_TYPES_SUCCESS';

export const CREATE_VEHICLE_TYPE_REQUEST = 'CREATE_VEHICLE_TYPE_REQUEST';
export const CREATE_VEHICLE_TYPE_SUCCESS = 'CREATE_VEHICLE_TYPE_SUCCESS';
export const CREATE_VEHICLE_TYPE_FAILED = 'CREATE_VEHICLE_TYPE_FAILED';
export const RESET_CREATE_VEHICLE_TYPE_SUCCESS = 'RESET_CREATE_VEHICLE_TYPE_SUCCESS';

export const FETCH_VEHICLE_TYPE_CATEGORIES_REQUEST = 'FETCH_VEHICLE_TYPE_CATEGORIES_REQUEST';
export const FETCH_VEHICLE_TYPE_CATEGORIES_SUCCESS = 'FETCH_VEHICLE_TYPE_CATEGORIES_SUCCESS';
export const FETCH_VEHICLE_TYPE_CATEGORIES_FAILED = 'FETCH_VEHICLE_TYPE_CATEGORIES_FAILED';
export const RESET_VEHICLES_TYPE_CATEGORIES_SUCCESS = 'RESET_VEHICLES_TYPE_CATEGORIES_SUCCESS';

export const UPDATE_VEHICLE_REQUEST = 'UPDATE_VEHICLE_REQUEST';
export const UPDATE_VEHICLE_SUCCESS = 'UPDATE_VEHICLE_SUCCESS';
export const UPDATE_VEHICLE_FAILED = 'UPDATE_VEHICLE_FAILED';

export const UPDATE_VEHICLE_TYPE_REQUEST = 'UPDATE_VEHICLE_TYPE_REQUEST';
export const UPDATE_VEHICLE_TYPE_SUCCESS = 'UPDATE_VEHICLE_TYPE_SUCCESS';
export const UPDATE_VEHICLE_TYPE_FAILED = 'UPDATE_VEHICLE_TYPE_FAILED';
export const RESET_UPDATE_VEHICLE_TYPE_SUCCESS = 'RESET_UPDATE_VEHICLE_TYPE_SUCCESS';

export const FETCH_ADD_SERVICES_TO_VEHICLES_REQUEST = 'FETCH_ADD_SERVICES_TO_VEHICLES_REQUEST';
export const FETCH_ADD_SERVICES_TO_VEHICLES_SUCCESS = 'FETCH_ADD_SERVICES_TO_VEHICLES_SUCCESS';
export const FETCH_ADD_SERVICES_TO_VEHICLES_FAILED = 'FETCH_ADD_SERVICES_TO_VEHICLES_FAILED';

export const FETCH_REMOVE_SERVICES_TO_VEHICLES_REQUEST =
  'FETCH_REMOVE_SERVICES_TO_VEHICLES_REQUEST';
export const FETCH_REMOVE_SERVICES_TO_VEHICLES_SUCCESS =
  'FETCH_REMOVE_SERVICES_TO_VEHICLES_SUCCESS';
export const FETCH_REMOVE_SERVICES_TO_VEHICLES_FAILED = 'FETCH_REMOVE_SERVICES_TO_VEHICLES_FAILED';

export const UPDATE_STEPS_LISTS_REQUEST = 'UPDATE_STEPS_LISTS_REQUEST';
export const UPDATE_STEPS_LISTS_SUCCESS = 'UPDATE_STEPS_LISTS_SUCCESS';
export const UPDATE_STEPS_LISTS_FAILED = 'UPDATE_STEPS_LISTS_FAILED';

export const UPDATE_VEHICLE_GROUP_REQUEST = 'UPDATE_VEHICLE_GROUP_REQUEST';
export const UPDATE_VEHICLE_GROUP_SUCCESS = 'UPDATE_VEHICLE_GROUP_SUCCESS';
export const UPDATE_VEHICLE_GROUP_FAILED = 'UPDATE_VEHICLE_GROUP_FAILED';

export const CHANGE_VEHICLE_GROUP_REQUEST = 'CHANGE_VEHICLE_GROUP_REQUEST';
export const CHANGE_VEHICLE_GROUP_SUCCESS = 'CHANGE_VEHICLE_GROUP_SUCCESS';
export const CHANGE_VEHICLE_GROUP_FAILED = 'CHANGE_VEHICLE_GROUP_FAILED';

export const CHANGE_VEHICLE_STATUS_REQUEST = 'CHANGE_VEHICLE_STATUS_REQUEST';
export const CHANGE_VEHICLE_STATUS_SUCCESS = 'CHANGE_VEHICLE_STATUS_SUCCESS';
export const CHANGE_VEHICLE_STATUS_FAILED = 'CHANGE_VEHICLE_STATUS_FAILED';
export const CHANGE_VEHICLE_STATUS_CONFLICT = 'CHANGE_VEHICLE_STATUS_CONFLICT';

export const RESET_CHANGE_STATUS_SUCCESS = 'RESET_CHANGE_STATUS_SUCCESS';

export const SET_VEHICLE_ACTION_REQUEST = 'SET_VEHICLE_ACTION_REQUEST';
export const SET_VEHICLE_ACTION_SUCCESS = 'SET_VEHICLE_ACTION_SUCCESS';
export const SET_VEHICLE_ACTION_FAILED = 'SET_VEHICLE_ACTION_FAILED';

export const SET_VEHICLE_PROFILE_IMAGE_REQUEST = 'SET_VEHICLE_PROFILE_IMAGE_REQUEST';
export const SET_VEHICLE_PROFILE_IMAGE_SUCCESS = 'SET_VEHICLE_PROFILE_IMAGE_SUCCESS';
export const SET_VEHICLE_PROFILE_IMAGE_FAILED = 'SET_VEHICLE_PROFILE_IMAGE_FAILED';

export const SET_VEHICLE_TYPE_PROFILE_IMAGE_REQUEST = 'SET_VEHICLE_TYPE_PROFILE_IMAGE_REQUEST';
export const SET_VEHICLE_TYPE_PROFILE_IMAGE_SUCCESS = 'SET_VEHICLE_TYPE_PROFILE_IMAGE_SUCCESS';
export const SET_VEHICLE_TYPE_PROFILE_IMAGE_FAILED = 'SET_VEHICLE_TYPE_PROFILE_IMAGE_FAILED';

export const DELETE_VEHICLE_IMAGES_REQUEST = 'DELETE_VEHICLE_IMAGES_REQUEST';
export const DELETE_VEHICLE_IMAGES_SUCCESS = 'DELETE_VEHICLE_IMAGES_SUCCESS';
export const DELETE_VEHICLE_IMAGES_FAILED = 'DELETE_VEHICLE_IMAGES_FAILED';

export const DELETE_VEHICLE_TYPE_IMAGES_REQUEST = 'DELETE_VEHICLE_TYPE_IMAGES_REQUEST';
export const DELETE_VEHICLE_TYPE_IMAGES_SUCCESS = 'DELETE_VEHICLE_TYPE_IMAGES_SUCCESS';
export const DELETE_VEHICLE_TYPE_IMAGES_FAILED = 'DELETE_VEHICLE_TYPE_IMAGES_FAILED';

export const FETCH_AVAILABLES_BROKERS_REQUEST = 'FETCH_AVAILABLES_BROKERS_REQUEST';
export const FETCH_AVAILABLES_BROKERS_SUCCESS = 'FETCH_AVAILABLES_BROKERS_SUCCESS';
export const FETCH_AVAILABLES_BROKERS_FAILED = 'FETCH_AVAILABLES_BROKERS_FAILED';

export const FETCH_VEHICLE_BROKERS_REQUEST = 'FETCH_VEHICLE_BROKERS_REQUEST';
export const FETCH_VEHICLE_BROKERS_SUCCESS = 'FETCH_VEHICLE_BROKERS_SUCCESS';
export const FETCH_VEHICLE_BROKERS_FAILED = 'FETCH_VEHICLE_BROKERS_FAILED';

export const FETCH_ADD_BROKER_REQUEST = 'FETCH_ADD_BROKER_REQUEST';
export const FETCH_ADD_BROKER_SUCCESS = 'FETCH_ADD_BROKER_SUCCESS';
export const FETCH_ADD_BROKER_FAILED = 'FETCH_ADD_BROKER_FAILED';

export const FETCH_REMOVE_BROKER_REQUEST = 'FETCH_REMOVE_BROKER_REQUEST';
export const FETCH_REMOVE_BROKER_SUCCESS = 'FETCH_REMOVE_BROKER_SUCCESS';
export const FETCH_REMOVE_BROKER_FAILED = 'FETCH_REMOVE_BROKER_FAILED';

export const UPLOAD_VEHICLE_IMAGE_REQUEST = 'UPLOAD_VEHICLE_IMAGE_REQUEST';
export const UPLOAD_VEHICLE_IMAGE_SUCCESS = 'UPLOAD_VEHICLE_IMAGE_SUCCESS';
export const UPLOAD_VEHICLE_IMAGE_FAILED = 'UPLOAD_VEHICLE_IMAGE_FAILED';
export const RESET_UPLOAD_VEHICLE_IMAGE_SUCCESS = 'RESET_UPLOAD_VEHICLE_IMAGE_SUCCESS';

export const UPLOAD_VEHICLE_TYPE_IMAGE_REQUEST = 'UPLOAD_VEHICLE_TYPE_IMAGE_REQUEST';
export const UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS = 'UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS';
export const UPLOAD_VEHICLE_TYPE_IMAGE_FAILED = 'UPLOAD_VEHICLE_TYPE_IMAGE_FAILED';
export const RESET_UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS = 'RESET_UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS';

export const FETCH_BULK_UPLOAD_REQUEST = 'FETCH_BULK_UPLOAD_REQUEST';
export const FETCH_BULK_UPLOAD_SUCCESS = 'FETCH_BULK_UPLOAD_SUCCESS';
export const FETCH_BULK_UPLOAD_FAILED = 'FETCH_BULK_UPLOAD_FAILED';
export const RESET_BULK_UPLOAD = 'RESET_BULK_UPLOAD';

export const FETCH_BULK_SHARING_REQUEST = 'FETCH_BULK_SHARING_REQUEST';
export const FETCH_BULK_SHARING_SUCCESS = 'FETCH_BULK_SHARING_SUCCESS';
export const FETCH_BULK_SHARING_FAILED = 'FETCH_BULK_SHARING_FAILED';
export const RESET_UPDATE_SHARING = 'RESET_UPDATE_SHARING';

export const FETCH_BULK_UNSHARE_REQUEST = 'FETCH_BULK_UNSHARE_REQUEST';
export const FETCH_BULK_UNSHARE_SUCCESS = 'FETCH_BULK_UNSHARE_SUCCESS';
export const FETCH_BULK_UNSHARE_FAILED = 'FETCH_BULK_UNSHARE_FAILED';
export const RESET_BULK_UNSHARE = 'RESET_BULK_UNSHARE';

export const FETCH_GET_BROKER_SETTINGS_REQUEST = 'FETCH_GET_BROKER_SETTINGS_REQUEST';
export const FETCH_GET_BROKER_SETTINGS_SUCCESS = 'FETCH_GET_BROKER_SETTINGS_SUCCESS';
export const FETCH_GET_BROKER_SETTINGS_FAILED = 'FETCH_GET_BROKER_SETTINGS_FAILED';

export const FETCH_UPDATE_BROKER_SETTINGS_REQUEST = 'FETCH_UPDATE_BROKER_SETTINGS_REQUEST';
export const FETCH_UPDATE_BROKER_SETTINGS_SUCCESS = 'FETCH_UPDATE_BROKER_SETTINGS_SUCCESS';
export const FETCH_UPDATE_BROKER_SETTINGS_FAILED = 'FETCH_UPDATE_BROKER_SETTINGS_FAILED';
export const RESET_UPDATE_BROKER_SETTING_SUCCESS = 'RESET_UPDATE_BROKER_SETTING_SUCCESS';

export const FETCH_VEHICLE_STATUSES_BY_ID_REQUEST = 'FETCH_VEHICLE_STATUSES_BY_ID_REQUEST';
export const FETCH_VEHICLE_STATUSES_BY_ID_SUCCESS = 'FETCH_VEHICLE_STATUSES_BY_ID_SUCCESS';
export const FETCH_VEHICLE_STATUSES_BY_ID_FAILED = 'FETCH_VEHICLE_STATUSES_BY_ID_FAILED';
